import * as React from 'react';

/** Three bars on a baseline: an overview of the numbers. Outline, currentColor,
 *  so it takes the sidebar's colour like every other row. */
function ChartBar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path d="M4 27h24" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
      <rect x={7} y={16} width={5} height={11} rx={1} stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" />
      <rect x={13.5} y={8} width={5} height={19} rx={1} stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" />
      <rect x={20} y={12} width={5} height={15} rx={1} stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" />
    </svg>
  );
}

export default ChartBar;
